import Layer from './BaseLayer';
import { CircleNodeQueue, CircleLineNodeQueue } from '../NodeQueue/index';

/**
* 图层节点
*/
class LineModeLayer extends Layer {
  constructor(props) {
    super(props);
  }

  init() {    
    this.lineNodeQuene = new CircleLineNodeQueue({
      render: this.render // flush副作用后渲染函数
    });
    this.lampNodeQueue =  new CircleNodeQueue({
      render: this.render
    });

    this.stage.add(this.stateNode);
  }
}

export default LineModeLayer;